.inProgressMajorAction {
  border-radius: 8px;
  margin-top: 20px;
  border: 1px solid var(--ds-pearl-grey-darker);
  padding: 8px 4px;

  & .actionChoice {
  }

  & ul {
    list-style: disc outside;
    margin-left: 25px;
  }
}
